import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=f4915aa6&scoped=true&"
import script from "./CustomForm.vue?vue&type=script&lang=js&"
export * from "./CustomForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=f4915aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4915aa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4915aa6')) {
      api.createRecord('f4915aa6', component.options)
    } else {
      api.reload('f4915aa6', component.options)
    }
    module.hot.accept("./CustomForm.vue?vue&type=template&id=f4915aa6&scoped=true&", function () {
      api.rerender('f4915aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/CustomForm.vue"
export default component.exports